export const SEND_CODE_URL = 'sentOtp'
export const LOGIN_URL = 'login'
export const GET_CSRF = 'csrf'
